<script>
    let cls = "sui-progress-circle";
    export let percent = 0;
    export let size = 25;
    export let line = 3;
    const pi = 3.1415926;

    let sizeBox = 2 * size;
    let r = size - line / 2;
    let c = 2 * pi * (size - line / 2);
    let offset = c * (1 - percent / 100);
    $: {
        sizeBox = 2 * size;
        r = size - line / 2;
        c = 2 * pi * (size - line / 2);
        offset = c * (1 - percent / 100);
    }
</script>

<div class={cls}>
    <div class={`${cls}-content`}>
        <svg
            class={`${cls}-svg`}
            style:--percent={percent}
            style:width={`${sizeBox}px`}
            style:height={`${sizeBox}px`}
        >
            <circle
                class={`${cls}-track`}
                cx={size}
                cy={size}
                {r}
                stroke="var(--track-color,#e5e5e5)"
                stroke-width={line}
                fill="transparent"
            />
            <circle
                class={`${cls}-fill`}
                cx={size}
                cy={size}
                stroke="var(--fill-color,var(--sui-color-primary))"
                stroke-width={line}
                {r}
                fill="transparent"
                stroke-dasharray={c}
                stroke-dashoffset={offset}
            />
        </svg>
        <div class={`${cls}-info`}>
            <slot />
        </div>
    </div>
</div>

<style lang="less">
    @import "./progressCricle.less";
</style>
